'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initFooter = initFooter;
exports.setLeftFooter = setLeftFooter;
exports.setCenterFooter = setCenterFooter;
exports.setRightFooter = setRightFooter;
exports.setClassNameFooter = setClassNameFooter;
// Action types
var INIT_FOOTER = exports.INIT_FOOTER = 'INIT_FOOTER';
var SET_LEFT_FOOTER = exports.SET_LEFT_FOOTER = 'SET_LEFT_FOOTER';
var SET_CENTER_FOOTER = exports.SET_CENTER_FOOTER = 'SET_CENTER_FOOTER';
var SET_RIGHT_FOOTER = exports.SET_RIGHT_FOOTER = 'SET_RIGHT_FOOTER';
var UPDATE_CLASS_FOOTER = exports.UPDATE_CLASS_FOOTER = 'UPDATE_CLASS_FOOTER';

function initFooter() {
    var footerInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isActive: false };

    return function (dispatch) {
        return dispatch({
            type: INIT_FOOTER,
            footerInfo: footerInfo
        });
    };
}

function setLeftFooter() {
    var leftFooter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        return dispatch({
            type: SET_LEFT_FOOTER,
            leftFooter: leftFooter
        });
    };
}

function setCenterFooter() {
    var centerFooter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        return dispatch({
            type: SET_CENTER_FOOTER,
            centerFooter: centerFooter
        });
    };
}

function setRightFooter() {
    var rightFooter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        return dispatch({
            type: SET_RIGHT_FOOTER,
            rightFooter: rightFooter
        });
    };
}
function setClassNameFooter() {
    var classFooter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        return dispatch({
            type: UPDATE_CLASS_FOOTER,
            classFooter: classFooter
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/footer.js
// module id = 778
// module chunks = 0